import React, { useContext } from 'react'
import { string, arrayOf, shape, array } from 'prop-types'
import classNames from 'classnames'
import { ThemeContext } from '@/component/Context/ThemeContext'

import styles from './BrandMap.module.scss'
import Container from '@/component/Primitive/Container'
import Type from '@/component/Primitive/Type'
import ChevronTitle from '@/component/Primitive/ChevronTitle'

const BrandMap = ({ title, stats }) => {
  const { theme } = useContext(ThemeContext)
  return (
    <div className={styles.BrandMap}>
      <Container size="wide" className={styles.BrandMapContainer} gutter center>
        <ChevronTitle className={styles.Title} title={title} />
        <div className={styles.Map}>
          <div className="Map">
            <img
              alt="World map showing community statistics"
              src={`/image/map/map-${theme}.svg`}
            />
          </div>
        </div>
      </Container>
      {stats && stats.length > 0 && (
        <Container size="wide" className={styles.StatsContainer} gutter center>
          <div className={styles.Stats}>
            {stats.map(({ locations }, i) => (
              <Stats key={i} values={locations} />
            ))}
          </div>
        </Container>
      )}
    </div>
  )
}

BrandMap.propTypes = {
  title: string,
  stats: array
}

export default BrandMap

const Stats = ({ values }) => (
  <ul className={styles.StatsWrapper}>
    {values.map(({ region, statistic }, i) => {
      const isFirst = i === 0
      const size = isFirst ? 'body1' : ['body2', 'body3']
      const weight = isFirst ? 'medium' : 'regular'
      return (
        <li
          key={region}
          className={classNames(styles.StatsItem, isFirst && styles.large)}
        >
          <Type size={size} weight={weight}>
            {region}
          </Type>
          <Type size={size} weight={weight}>
            {statistic}
          </Type>
        </li>
      )
    })}
  </ul>
)

Stats.propTypes = {
  values: arrayOf(
    shape({
      region: string,
      statistic: string
    })
  ).isRequired
}
